export default "__VITE_ASSET__EMfzVvJG__"